<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 900px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -450px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}

.title-close div {
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  /* margin-top: 15px; */
  float: right;
  margin-right: 10px;
  line-height: 28px;
  cursor: pointer;
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}

/deep/ .el-table td {
  padding: 10px 0px;
}

/deep/.el-input-number__decrease {
  height: 33px;
  top: 3px
}

/deep/ .el-input-number__increase {
  height: 33px;
  top: 3px
}

.table-wrap {
  margin: 10px 20px 20px 20px;
  text-align: left;

}

.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color: #666;
}
</style>
<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-close">
        <div class="title" style="margin-bottom:0">删除人员任务</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="person-search">
        <div class="item1">
          <div class="label">选择人员</div>
          <el-select multiple collapse-tags="true" class="select-wrap" v-model="page.staffGuidList"
            placeholder="请选择人员，可多选" filterable>
            <el-option v-for="item in staffList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item1">
          <div class="label">任务名称</div>
          <el-select multiple :collapse-tags="true" class="select-wrap" v-model="page.taskDetailGuidList"
            placeholder="请选择任务，可多选" filterable>
            <el-option v-for="item in taskList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item1">
          <div class="btns" @click="search">
            搜索
          </div>
          <div class="btns cancel" @click="empty">
            清空
          </div>
        </div>
      </div>
      <div class="table-wrap">
        <el-button style="margin-bottom: 10px;" size="mini" type="info"
          @click="deletePeople(multipleSelection)">批量删除</el-button>
        <el-table @selection-change="handleSelectionChange" :data="detailData" max-height="490px" width="660px" stripe
          border header-cell-class-name="table_header">
          <el-table-column fixed="left" type="selection" :selectable="selectable" width="60" header-align="center"
            align="center"></el-table-column>
          <el-table-column fixed="left" label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">{{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="任务名称" show-overflow-tooltip width="200" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column label="人员名称" show-overflow-tooltip width="100" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column label="平台账号" show-overflow-tooltip width="120" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
          </el-table-column>
          <el-table-column label="备案部门" show-overflow-tooltip width="180" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
          </el-table-column>
          <el-table-column label="已完成量" show-overflow-tooltip width="80" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.realCount }}</template>
          </el-table-column>
          <el-table-column label="任务量" show-overflow-tooltip width="80" header-align="center" align="left">
            <template slot-scope="scope">
              <div v-if="!scope.row.isNotLimit">
                {{ scope.row.planCount }}
              </div>
              <div v-else>
                不限量
              </div>
            </template>

          </el-table-column>
          <el-table-column label="操作" fixed="right" width="80" header-align="center" align="center">
            <template slot-scope="scope">
              <a v-if="scope.row.realCount == 0" class="txt-color"  @click="deletePeople([{ guid: scope.row.guid, taskMainGuid: scope.row.taskMainGuid, taskDetailGuid: scope.row.taskDetailGuid, staffGuid: scope.row.staffGuid }])">删除</a>
              <a v-else>不可删除</a>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination style="margin-top:10px;width:860px;text-align: center;" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 50, 100, 200]" current-page="page.pageIndex"
          :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
      </div>
      <div class="btns " @click="close">
        关闭
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskMainGuid: this.$route.query.guid,
        staffGuidList: [],
        taskDetailGuidList: []
      },
      multipleSelection: [],
      staffList: [],
      taskList: [],
      organisationNames: '',
      detailData: [],
      fullscreenLoading: false
    };
  },
  created() {
    this.getStaffList();
    this.getTaskList();
    this.getList();
  },
  methods: {

    close() {
      this.$emit('close')
    },
    submit() {
      console.log(this.detail);
    },
    //查询人
    getStaffList() {
      let query = {
        taskMainGuid: this.$route.query.guid,
      };
      this.fullscreenLoading = true;
      this.api.get(`/${serverConfig.msSalesPerformService}/task/get-select-task-staff-list`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //查询任务明细
    getTaskList() {
      let query = {
        taskMainGuid: this.$route.query.guid,
      };
      this.fullscreenLoading = true;
      this.api.get(`/${serverConfig.msSalesPerformService}/task/get-select-task-detail-list`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.taskList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach(item => {
        this.multipleSelection.push({ guid: item.guid, taskMainGuid: item.taskMainGuid, taskDetailGuid: item.taskDetailGuid, staffGuid: item.staffGuid });
      });
    },
    staffChange(val) {
      this.staffList.forEach(item => {
        if (item.staffGuid == val) {
          console.log(item)
          this.organisationNames = item.organisationNames ? item.organisationNames.join('、') : '';
        }
      })
      this.getDetailList()
    },
    //查询明细
    getList() {
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/page-staff-task-info`, this.page).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.detailData = res.data.data.records;
          this.page.totalPage = res.data.data.totalPages;
          this.page.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    empty() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskMainGuid: this.$route.query.guid,
        staffGuidList: [],
        taskDetailGuidList: []
      }
      this.getList();
    },
    search() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskMainGuid: this.$route.query.guid,
        staffGuidList:  this.page.staffGuidList,
        taskDetailGuidList: this.page.taskDetailGuidList
      }
      this.getList();
    },
    //删除
    deletePeople(list) {
      if (!list.length) {
        this.$message.error('请选择要删除的数据!');
        return;
      }
      let req = [];
      let ajaxMethod = this.isShenHe() ? 'postJson' : 'deletes';
      let url = this.isShenHe() ? `/${serverConfig.msSalesPerformService}/task-flow-approve/del-plan-batch-todo` : `/${serverConfig.msSalesPerformService}/task/task-detail-staff/delete`;
      if (this.isShenHe()) {
        req = list;
      } else {
        list.forEach(item => {
          req.push(item.guid);
        })
      }
      this.$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.fullscreenLoading = true;
        this.api.postJson(url, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(this.isShenHe() ? '操作成功，请点击【任务变更提审】按钮提审！' : '删除成功');
            //清空表单
            this.empty();
            this.close();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
    },
    isShenHe() {
      let state = this.detail.state;
      let bizApproveVO = this.detail.bizApproveVO;
      if (state == '待派发') {
        return false;
      }
      if ((state == '已派发'||state == '部分结算')&& bizApproveVO ) {
        return true;
      }
      return false;
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getList();
    },
    selectable(row, index) {
      if (!row.realCount) {
        return true;
      }
    }

  },
};
</script>